import { Download, Store, CheckCircle2 } from "lucide-react";
import { PurchasesShot } from "@/components/PurchasesShot";

const POINTS = [
  { icon: Download, text: "Нажмите «Получить аккаунт» и пройдите короткую пошаговую инструкцию." },
  { icon: Store, text: "Войдите в общий аккаунт в App Store." },
  { icon: CheckCircle2, text: "В разделе «Покупки» установите нужное приложение." },
];

export default function InstallGuide({ appName }) {
  return (
    <div className="space-y-4">
      <div className="rounded-2xl bg-white/[0.03] border border-white/10 p-4 space-y-3">
        {POINTS.map((p, i) => {
          const Icon = p.icon;
          return (
            <div key={i} data-testid={`install-step-${i + 1}`} className="flex items-start gap-3">
              <span className="shrink-0 w-8 h-8 grid place-items-center rounded-xl bg-blue-500/15 text-blue-300 border border-blue-500/30">
                <Icon size={16} />
              </span>
              <div className="text-sm text-slate-300 leading-relaxed self-center">{p.text}</div>
            </div>
          );
        })}
      </div>

      <div className="rounded-2xl bg-white/[0.03] border border-white/10 p-4 space-y-3">
        <div className="text-sm font-semibold">Экран «Покупки» в App Store</div>
        <p className="text-xs text-slate-400 leading-relaxed">
          Откройте App Store → ваш профиль вверху → «Покупки» / «Не на этом iPhone» и нажмите на облачко рядом с нужным
          приложением.
        </p>
        <PurchasesShot highlightName={appName} />
      </div>
    </div>
  );
}
